import { useEffect } from "react";

const APP_NAME = "ADC";

// An effect hook that sets the window title.
export const useTitle = (title = APP_NAME, enabled = true) => {
  useEffect(() => {
    if (!enabled) return;
    document.title = title;

    return () => {
      document.title = APP_NAME;
    };
  }, [title, enabled]);
};
